import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

export default function DetailsModal({ student, course, levels = [], batch }) {
  const [formData, setFormData] = useState({});
  const [paymentValues, setPaymentValues] = useState({});

  // Initialize form and payments when student changes
  useEffect(() => {
    if (student) {
      setFormData({
        name: student.name,
        fatherName: student.fatherName,
        phone: student.phone,
        gender: student.gender,
      });

      const existingPayments = {};
      levels.forEach((level) => {
        const key = `${course}${level}payment`;
        if (student[key] !== undefined) existingPayments[key] = student[key];
      });
      setPaymentValues(existingPayments);
    }
  }, [student, course, levels]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePaymentChange = (e, key) => {
    const { value } = e.target;
    setPaymentValues((prev) => ({ ...prev, [key]: value }));
  };

  const updatFile = (data) => {
    axios
      .put(
        `${process.env.REACT_APP_BACKEND_API}/${course}/accessLevelTwo/${batch}/${student.sn}`,
        data
      )
      .then(() => toast.success("Data updated!"));
  };

  const updateData = (e) => {
    e.preventDefault();
    const updatedData = {
      sn: student.sn,
      ...formData,
      ...paymentValues, // spread payments at top level
    };
    updatFile(updatedData);
  };

  const makeA = () => {
    const updatedData = {
      sn: student.sn,
      name: "a",
      fatherName: "a",
      phone: "unknown",
      gender: "male",
      ...paymentValues,
    };
    updatFile(updatedData);
  };

  if (!student) return null;

  return (
    <dialog id="my_modal_4" className="modal">
      <div className="modal-box w-full max-w-5xl mx-auto">
        <form method="dialog">
          <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">
            ✕
          </button>
        </form>

        <h3 className="font-bold text-lg">
          {student.sn} # {student.name.toUpperCase()}
        </h3>

        <form onSubmit={updateData} className="flex flex-col gap-4 mt-4">
          {/* Name */}
          <div className="flex items-center gap-2">
            <label htmlFor="name" className="w-1/5">
              Name
            </label>
            <input
              name="name"
              type="text"
              value={formData.name || ""}
              onChange={handleInputChange}
              className="input input-ghost w-4/5"
            />
          </div>

          {/* Father's Name */}
          <div className="flex items-center gap-2">
            <label htmlFor="fatherName" className="w-1/5">
              Father's Name
            </label>
            <input
              name="fatherName"
              type="text"
              value={formData.fatherName || ""}
              onChange={handleInputChange}
              className="input input-ghost w-4/5"
            />
          </div>

          {/* Gender */}
          <div className="flex items-center gap-2">
            <label htmlFor="gender" className="w-1/5">
              Gender
            </label>
            <input
              name="gender"
              type="text"
              value={formData.gender || ""}
              onChange={handleInputChange}
              className="input input-ghost w-4/5"
            />
          </div>

          {/* Phone */}
          <div className="flex items-center gap-2">
            <label htmlFor="phone" className="w-1/5">
              <FontAwesomeIcon icon="fa-solid fa-phone" />
            </label>
            <input
              name="phone"
              type="text"
              value={formData.phone || ""}
              onChange={handleInputChange}
              className="input input-ghost w-4/5"
            />
          </div>

          {/* Existing payments */}
          {Object.keys(paymentValues).length > 0 && (
            <>
              <p className="mt-4 font-semibold">{course} Payments</p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 px-4">
                {Object.entries(paymentValues).map(([key, value]) => {
                  const level = key.match(/\d+/)[0];
                  return (
                    <div key={key} className="w-full text-center">
                      <p className="my-2">Level {level}</p>
                      <select
                        value={value}
                        onChange={(e) => handlePaymentChange(e, key)}
                        className="select select-bordered w-full"
                      >
                        <option value="paid">Paid 🟢</option>
                        <option value="due">Due 🟠</option>
                        <option value="scholarship">Scholarship 🔵</option>
                      </select>
                    </div>
                  );
                })}
              </div>
            </>
          )}

          {/* Modal Actions */}
          <div className="flex justify-between gap-4 mt-8">
            <button
              type="button"
              className="rounded-lg px-4 btn bg-slate-400"
              onClick={makeA}
            >
              Make A
            </button>
            <button type="submit" className="rounded-lg px-4 btn bg-yellow-400">
              Update
            </button>
          </div>
        </form>
      </div>
    </dialog>
  );
}
